import styled from 'styled-components';

export const TableData1A = styled.span`
  font-size: 14;
  line-height: 20;
  color: #155cb4;
  font-family: 'EYInterstate Light';
`;
export const TableData1ACell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  color: red;
`;
export const TableData1B = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  border: 1px solid #e1e1e6 #c4c4cd;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'EYInterstate Light';
`;
export const TableData1BCell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;

export const TableData1C = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  border: 1px solid #e1e1e6 #c4c4cd;
  display: flex;
  flex-direction: row; /* Ensure horizontal alignment */
  align-items: center;
`;

export const TableData1CCell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;
export const TableData2ANumStyle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  /* fontWeight: 'light', */
  font-family: 'EYInterstate Light';
`;

export const TableData2ACell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  padding: 12px 10px;
  margin: 10px;
`;

export const TableData2BNumStyle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  font-weight: bold;
  font-family: 'EYInterstate Light Bold';
`;

export const TableData2BCell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6; /* Fixed missing '1px solid' */
  background-color: #e1e1e6;
  padding: 12px 10px;
`;
export const TableData3Text = styled.span`
  color: #2e2e38;
  font-family: 'EYInterstate Light';
  font-size: 14px;
`;

export const TableData3ACell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  padding: 12px 10px;
  margin: 10px;
`;
export const TableData3DotStyle = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${props => props.backgroundColor || 'red'};
  border-radius: 50%;
  margin-right: 10px;
`;

export const TableData4Cell = styled.span`
  height: 50px;
  width: 200px;
  border-color: #e1e1e6;
  border-width: 1px;
  border-style: solid;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
`;
export const TableData5Text = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #155cb4;
  font-family: 'EYInterstate Light Bold';
  margin-left: 10px;
`;
export const TableData5Cell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;
export const TableData5Icon = styled.span`
  margin-left: auto;
  margin-right: 10px;
  color: #155cb4;
`;
export const TableData6Text = styled.span`
  color: #2e2e38;
  font-family: 'EYInterstate Light';
  align-items: left;
`;
export const TableData6Cell = styled.span`
  display: flex;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6; /* Assuming 'E1E1E6' is the color, also added 'solid' */
  padding: 12px 5px;
`;
export const TableData7Cell = styled.span`
  height: 50px;
  width: 200px;
  border-color: #e1e1e6;
  border-width: 1px;
  border-style: solid;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
`;
export const TableToggle = styled.span`
  font-size: 14px;
  line-height: 20px;
`;

export const TableData1BDarkBold = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: white;
  border: 1px solid #e1e1e6 #c4c4cd;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-family: 'EYInterstate Light';
`;

export const TableData1BDark = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'EYInterstate';
  font-weight: 600;
  margin-right: 15px;
`;

export const TableData1CDark = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: white;
  display: flex;
  flex-direction: row; /* Ensure horizontal alignment */
  justify-content: space-between;
  align-items: center;
  font-family: 'EYInterstate';
  font-weight: 300;
  margin-right: 15px;
`;

export const GCSPHeadTable = styled.div`
  width: 100%;
  height: 60vh;
`;

export const FooterTable = styled.div`
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.25);
  max-width: 100%;
`;

export const LoadingSpinnerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
`;

export const GcspPastTableContainer = styled.div`
  max-width: 1920px;
  flex: 2;
  height: 365px;
`;

export const GcspPastFooterTableContainer = styled.div`
  max-width: 1920px;
  height: 236px;
`;

export const GcspFooterColumnRenderer = styled.div`
  display: flex;
  align-items: center;
`;

export const GcspStatusCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
